import { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
	Button,
	Card,
	Col,
	Form,
	Image,
	Input,
	InputNumber,
	List,
	PageHeader,
	Row,
	Select,
	Spin,
} from "antd";
import { debounce } from "lodash";

// import { CheckPermission } from "scripts/helpers";
import { setRoute } from "scripts/reducer";
import { Permissions, Types } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import UploadImage from "components/UploadImage";

const Component = ({
	onSetRoute,
	parentName,
	// permissions,
	routeName,
	settings,
}) => {
	const initialState = { images: [] };
	const [state, setState] = useState(initialState);
	const { data, fetching, loaded, submitting, videos, images } = state;
	const [form] = Form.useForm();

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				values.defaultCategoryCoverId = values.defaultCategoryCover.id;
				values.defaultCourseCoverId = values.defaultCourseCover.id;
				values.defaultSessionCoverId = values.defaultSessionCover.id;
				values.defaultUserAvatarId = values.defaultUserAvatar.id;
				if (values.introVideoId.value)
					values.introVideoId = values.introVideoId.value;

				delete values.defaultUserAvatar;
				delete values.defaultSessionCover;
				delete values.defaultCourseCover;
				delete values.defaultCategoryCover;

				API.setting.update(values).finally(() => {
					setState((prevState) => ({ ...prevState, submitting: false }));
				});
			});
		}
	};

	const handleVideos = debounce((e) => {
		setState((prevState) => ({
			...prevState,
			fetching: true,
		}));
		API.videos
			.list({
				search: e,
				pageSize: process.env.REACT_APP_PAGE_SIZE,
				section: Types.upload.default,
			})
			.then(({ data }) => {
				setState((prevState) => ({
					...prevState,
					videos: data.map(({ id, title }) => ({ label: title, value: id })),
					fetching: false,
				}));
			});
	}, 1000);

	const componentDidMount = () => {
		onSetRoute({ openKey: parentName, selectedKey: routeName });
		Promise.all([
			API.videos.list({
				pageSize: process.env.REACT_APP_PAGE_SIZE,
				section: Types.upload.default,
			}),
			API.gallery.list({ paginate: false }),
		]).then(([{ data: videos }, { data: images }]) => {
			setState((prevState) => ({
				...prevState,
				videos: videos.map(({ id, title }) => ({ label: title, value: id })),
				images: images.map(({ id, title }) => ({ label: title, value: id })),
				fetching: false,
			}));
		});

		API.setting.details().then(({ data }) => {
			setState((prevState) => ({ ...prevState, data, loaded: true }));
			console.log(data);
			form.setFieldsValue({
				...data,
				introVideoId: {
					value: data?.introVideo?.id,
					label: data?.introVideo?.title,
				},
			});
		});

		// if (permissions.update) {
		// }
	};

	useEffect(componentDidMount, []);

	return (
		<>
			<PageHeader title={Resources.settings} />
			<Row className="sp-content-center">
				<Col
					xs={24}
					md={18}
					lg={12}
				>
					<Card>
						{loaded ? (
							// permissions.update ? (
							<>
								<Form
									layout="vertical"
									form={form}
								>
									<Row gutter={[16, 8]}>
										<Col xs={24}>
											<Form.Item
												name="introVideoId"
												label={`${Resources.video} ${Resources.training}${Resources.y}`}
											>
												<Select
													options={videos}
													loading={fetching}
													optionFilterProp="label"
													showSearch
													placeholder={`${Resources.search} ${Resources.do}`}
													onSearch={(e) => handleVideos(e)}
												/>
											</Form.Item>
										</Col>
										<Col
											xs={24}
											md={12}
										>
											<Form.Item
												name="defaultCategoryCover"
												label={`${Resources.image} ${Resources.default} ${Resources.categories}`}
											>
												<Select
													options={images}
													optionFilterProp="label"
													showSearch
												/>
											</Form.Item>
										</Col>
										<Col
											xs={24}
											md={12}
										>
											<Form.Item
												name="defaultCourseCover"
												label={`${Resources.image} ${Resources.default} ${Resources.course}${Resources.ha}`}
											>
												<Select
													options={images}
													optionFilterProp="label"
													showSearch
												/>
											</Form.Item>
										</Col>
										<Col
											xs={24}
											md={12}
										>
											<Form.Item
												name="defaultSessionCover"
												label={`${Resources.image} ${Resources.default} ${Resources.session}${Resources.ha}`}
											>
												<Select
													options={images}
													optionFilterProp="label"
													showSearch
												/>
											</Form.Item>
										</Col>
										<Col
											xs={24}
											md={12}
										>
											<Form.Item
												name="defaultUserAvatar"
												label={`${Resources.image} ${Resources.default} ${Resources.user}${Resources.ha}`}
											>
												<Select
													options={images}
													optionFilterProp="label"
													showSearch
												/>
											</Form.Item>
										</Col>
										<Col xs={24}>
											<Form.Item
												name="staticBannerText"
												label={`${Resources.text} ${Resources.banner}`}
											>
												<Input.TextArea rows={4} />
											</Form.Item>
										</Col>
										<Col xs={24}>
											<Form.Item
												name="shareDescription"
												label={`${Resources.text} ${Resources.share}`}
											>
												<Input.TextArea rows={4} />
											</Form.Item>
										</Col>
									</Row>
								</Form>
								<Button
									type="primary"
									onClick={handleSubmit}
									loading={submitting}
									style={{ float: "left", marginTop: 16 }}
								>
									{Resources.confirm}
								</Button>
							</>
						) : (
							// ) : (
							// 	<List>
							// 		<List.Item>
							// 			<List.Item.Meta
							// 				title={`${Resources.video} ${Resources.intro}`}
							// 				description={videos?.filter(
							// 					(vid) => vid.id === data?.introVideo?.id
							// 				)}
							// 			/>
							// 		</List.Item>
							// 		<List.Item>
							// 			<List.Item.Meta
							// 				title={`${Resources.count} ${Resources.device} ${Resources.user}`}
							// 				description={data?.userDevicesLimit}
							// 			/>
							// 		</List.Item>
							// 		<List.Item>
							// 			<List.Item.Meta
							// 				title={`${Resources.image} ${Resources.default} ${Resources.categories}`}
							// 				description={
							// 					<Image src={data?.defaultCategoryCover?.url} />
							// 				}
							// 			/>
							// 		</List.Item>
							// 		<List.Item>
							// 			<List.Item.Meta
							// 				title={`${Resources.image} ${Resources.default} ${Resources.course}${Resources.ha}`}
							// 				description={
							// 					<Image src={data?.defaultCourseCover?.url} />
							// 				}
							// 			/>
							// 		</List.Item>
							// 		<List.Item>
							// 			<List.Item.Meta
							// 				title={`${Resources.image} ${Resources.default} ${Resources.session}${Resources.ha}`}
							// 				description={
							// 					<Image src={data?.defaultSessionCover?.url} />
							// 				}
							// 			/>
							// 		</List.Item>
							// 		<List.Item>
							// 			<List.Item.Meta
							// 				title={`${Resources.image} ${Resources.default} ${Resources.user}${Resources.ha}`}
							// 				description={<Image src={data?.defaultUserAvatar?.url} />}
							// 			/>
							// 		</List.Item>
							// 		<List.Item>
							// 			<List.Item.Meta
							// 				title={`${Resources.text} ${Resources.banner}`}
							// 				description={data?.staticBannerText}
							// 			/>
							// 		</List.Item>
							// 	</List>
							// )
							<Spin className="sp-block-spin" />
						)}
					</Card>
				</Col>
			</Row>
		</>
	);
};

export default connect(
	(state) => {
		return {
			// permissions: {
			// 	update: CheckPermission(
			// 		state.user.permissions,
			// 		Permissions.SETTING_UPDATE
			// 	),
			// },
		};
	},
	(dispatch) => {
		return {
			onSetRoute: (data) => dispatch(setRoute(data)),
		};
	}
)(Component);
